import React, { isValidElement, Fragment } from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function maestroComponent(displayName, Component, compoundComponents) {
  Component.displayName = displayName;
  if (compoundComponents) {
    Component = Object.assign(Component, compoundComponents);
  }
  return Component;
}
function findChildWithDisplayName(children, displayName) {
  var _a;
  const childrenArray = children ? React.Children.toArray(children) : [];
  let result;
  if (children && displayName) {
    for (let i = 0; i < childrenArray.length; i++) {
      const child = childrenArray[i];
      if (!isValidElement(child)) {
        continue;
      }
      const { type } = child;
      if (type === (/* @__PURE__ */ React.createElement(Fragment, null)).type && child.props.children) {
        const deepChild = findChildWithDisplayName(child.props.children, displayName);
        if (deepChild) {
          result = deepChild;
          break;
        }
      }
      if (typeof type === "string") {
        continue;
      }
      if ((_a = type == null ? void 0 : type.displayName) == null ? void 0 : _a.includes(displayName)) {
        result = child;
        break;
      }
    }
  }
  return result;
}
function findAllChildrenWithDisplayName(children, displayName) {
  const childrenArray = children ? React.Children.toArray(children) : [];
  if (children && displayName) {
    const flatten = (acc, child) => {
      if (Array.isArray(child)) {
        return [...acc, ...child.reduce(flatten)];
      }
      return [...acc, child];
    };
    return childrenArray.map((child) => {
      var _a;
      if (!isValidElement(child)) {
        return null;
      }
      const { type } = child;
      if (type === (/* @__PURE__ */ React.createElement(Fragment, null)).type && child.props.children) {
        return findAllChildrenWithDisplayName(React.Children.toArray(child.props.children), displayName);
      }
      if (typeof type === "string") {
        return null;
      }
      if ((_a = type == null ? void 0 : type.displayName) == null ? void 0 : _a.includes(displayName)) {
        return child;
      }
      return null;
    }).filter((child) => Boolean(child)).reduce(flatten, []);
  }
  return [];
}
const getClonedChild = (children, displayName, props) => {
  if (displayName && children) {
    const child = findChildWithDisplayName(children, displayName);
    if (isValidElement(child)) {
      return React.cloneElement(child, props && __spreadValues({}, props));
    }
  }
  return null;
};
const getClonedChildWithMergedProps = (children, displayName, props) => {
  if (displayName && children) {
    const child = findChildWithDisplayName(children, displayName);
    if (isValidElement(child)) {
      return React.cloneElement(child, __spreadValues(__spreadValues({}, props), child.props));
    }
  }
  return null;
};
const getDisplayName = (Component) => {
  var _a;
  return (_a = Component == null ? void 0 : Component.type) == null ? void 0 : _a.displayName;
};

export { findAllChildrenWithDisplayName, findChildWithDisplayName, getClonedChild, getClonedChildWithMergedProps, getDisplayName, maestroComponent };
//# sourceMappingURL=componentHelpers.es.js.map
